// @ts-nocheck
import { useState, useRef, useReducer, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { ColorPicker } from 'primereact/colorpicker';
import { InputText } from 'primereact/inputtext';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import "../assets/functionalComponents/_dialog.scss"
import "../assets/functionalComponents/_dataItem.scss"

var tokml = require("tokml");

export const MarkComponents = (props: { Analysis: any; onHide: (arg0: string) => any; }) => {
    const [color, setColor] = useState("F17013");
    const [markType,] = useState([
        { value: 0, label: "點" },
        { value: 1, label: "線" },
        { value: 2, label: "面" },
    ]);
    const [selectType, setSelectType] = useState(0);
    const [markIcons, setMarkIcons] = useState([]);
    const [selectMarkIcon, setSelectMarkIcon] = useState("");
    const [markText, setMarkText] = useState("");
    const [markArray, setMarkArray] = useState([]);
    const [markGeo, setMarkGeo] = useState(null);
    const [, forceUpdate] = useReducer(num => num + 1, 0);
    const toast = useRef(null);

    useEffect(() => {
        setMarkIcons(window.MARK_ICON_LIST);
        setSelectMarkIcon(window.MARK_ICON_LIST[0]);
    }, []);

    useEffect(() => {
        return () => {
            window.main.OView.abortInput();
            window.main.OView.updateScreen();
        }
    }, []);

    useEffect(() => {
        if (markGeo === null)
            return;
        let param = null;
        let entity = null;
        let array = [];
        let _mark = null;
        let item = {};
        let paramText = null;
        let entityText = null;
        switch (selectType) {
            case 0:
                item = {};
                let url = `https://api.tiles.mapbox.com/v3/marker/pin-l-${selectMarkIcon.icon}+${color}@2x.png`;
                param = {
                    geo: new GeoPoint(markGeo.x, markGeo.y, 0),
                    symbol: url,
                    opacity: 1,
                    size: 48,
                    absHeight: false
                };
                if (markText !== "") {
                    param.label = textStyle(markText);
                    param.labelOffset = new GeoPoint(0, 28)
                }

                _mark = window.main.OView.findLayer("mark");
                if (_mark === null) {
                    _mark = window.main.OView.addCustomLayer({
                        layername: "mark"
                    });
                }
                _mark.setDepthFunc(window.ov.DEPTH_FUNC.ALWAYS);
                entity = _mark.addPointEntity(param);
                item.entity = entity;
                item.color = color;
                item.symbol = selectMarkIcon.icon;
                array = markArray;
                array.push(item);
                setMarkArray(array);
                break;
            case 1:
                item = {};
                param = {
                    geo: new GeoPolyline(markGeo),
                    color: new window.ov.Color(color),
                    opacity: 0.8,
                    worldSize: false,
                    size: 4,
                    coverModel: true
                };
                _mark = window.main.OView.findLayer("mark");
                if (_mark === null) {
                    _mark = window.main.OView.addCustomLayer({
                        layername: "mark"
                    });
                }
                _mark.setDepthFunc(window.ov.DEPTH_FUNC.ALWAYS);
                entity = _mark.addSurfacePolylineEntity(param);
                item.entity = entity;
                if (markText !== "") {
                    paramText = {
                        geo: param.geo.Buffer[0],
                        opacity: 0,
                        size: 1,
                        label: textStyle(markText)
                    }
                    entityText = _mark.addPointEntity(paramText);
                    item.entityText = entityText;
                }
                array = markArray;
                item.color = color;
                array.push(item);
                setMarkArray(array);
                break;
            case 2:
                item = {};
                param = {
                    geo: new GeoPolygon(markGeo),
                    color: new window.ov.Color(color),
                    opacity: 0.8,
                    coverModel: true
                }
                _mark = window.main.OView.findLayer("mark");
                if (_mark === null) {
                    _mark = window.main.OView.addCustomLayer({
                        layername: "mark"
                    });
                }
                _mark.setDepthFunc(window.ov.DEPTH_FUNC.ALWAYS);
                entity = _mark.addSurfacePolygonSetEntity(param);
                item.entity = entity;
                if (markText !== "") {
                    let x = 0, y = 0, z = 0;
                    for (let i = 0; i < param.geo.Buffer.length; i++) {
                        x += param.geo.Buffer[i].x;
                        y += param.geo.Buffer[i].y;
                        z += param.geo.Buffer[i].z;
                    }
                    x /= param.geo.Buffer.length;
                    y /= param.geo.Buffer.length;
                    z /= param.geo.Buffer.length;

                    paramText = {
                        geo: new GeoPoint(x, y, z),
                        opacity: 0,
                        size: 1,
                        label: textStyle(markText)
                    }
                    entityText = _mark.addPointEntity(paramText);
                    item.entityText = entityText;
                }
                array = markArray;
                item.color = color;
                array.push(item);
                setMarkArray(array);
                break;
            default:
                break;
        }
    }, [markGeo])

    function textStyle(text) {
        return {
            color: new GLCOLOR({ r: 1.0, g: 1.0, b: 1.0, a: 1.0 }),
            text: text,
            font: "標楷體",
            size: 18,
            borderColor: new GLCOLOR({ r: 0.0, g: 0.0, b: 0.0, a: 1.0 }),
            borderSize: 3
        }
    }

    const markOutput = (event) => {
        if (event.success) {
            setMarkGeo(event.geo);
            forceUpdate();
            window.main.OView.removeEventListener("InputCompleted", markOutput);
        }
    }

    const startMark = () => {
        window.main.OView.addEventListener("InputCompleted", markOutput);
        switch (selectType) {
            case 0:
                toast.current.show({ severity: 'info', summary: '標註資訊', detail: '請點擊滑鼠左鍵開始標註' });
                window.main.OView.inputSurfacePoint();
                break;
            case 1:
                toast.current.show({ severity: 'info', summary: '標註資訊', detail: '請點擊滑鼠左鍵開始標註' });
                window.main.OView.inputSurfacePolyline();
                break;
            case 2:
                toast.current.show({ severity: 'info', summary: '標註資訊', detail: '請點擊滑鼠左鍵開始標註' });
                window.main.OView.inputSurfacePolygon();
                break;
            default:
                break;

        }
    }

    const removeLastEmtity = () => {
        let _mark = window.main.OView.findLayer("mark");
        if (_mark === null) {
            toast.current.show({ severity: 'error', summary: '標註資訊', detail: '沒有標註可以清除' });
            return
        }
        let array = markArray;
        let entity = array[array.length - 1];
        if (entity === undefined) {
            toast.current.show({ severity: 'error', summary: '標註資訊', detail: '沒有標註可以清除' });
            return;
        }
        _mark.removeEntity(entity.entity);
        if (entity.entityText) {
            _mark.removeEntity(entity.entityText);
        }
        array.splice(array.length - 1, 1);
        setMarkArray(array);
    }

    const removeAllEmtity = () => {
        let _mark = window.main.OView.findLayer("mark");
        if (_mark === null) {
            toast.current.show({ severity: 'error', summary: '標註資訊', detail: '沒有標註可以清除' });
            return;
        }
        if (markArray.length === 0) {
            toast.current.show({ severity: 'error', summary: '標註資訊', detail: '沒有標註可以清除' });
            return;
        }
        _mark.removeAllEntity();
        setMarkArray([]);
    }

    const exportKML = () => {
        if (markArray.length !== 0) {
            let exportData = { type: "FeatureCollection", features: [] };
            markArray.forEach((item, index) => {
                let entity = null;
                entity = item.entity.getParameter();
                let geo = entity.geo;
                let text = null;
                let geometry = null;
                let properties = null;
                let name = "第" + (index + 1) + "次標註";

                if (geo instanceof Geo3DPoint) {
                    text = entity.label.text;
                    properties = {
                        "name": name,
                        "text": text,
                        "marker-color": "#" + item.color,
                        "marker-size": "large",
                        "marker-symbol": item.symbol
                    }
                    geometry = {
                        type: "Point",
                        coordinates: [
                            [
                                [geo.x, geo.y]
                            ]
                        ]
                    }
                }
                else if (geo instanceof GeoPolyline) {
                    if (item.entityText) text = item.entityText.getParameter().label.text;
                    else text = "";

                    properties = {
                        "name": name,
                        "text": text,
                        "stroke": "#" + item.color,
                        "stroke-width": 2,
                        "stroke-opacity": 1
                    }
                    let coord = [];
                    for (let i = 0; i < geo.Buffer.length - 1; i++) {
                        coord.push([[geo.Buffer[i].x, geo.Buffer[i].y], [geo.Buffer[i + 1].x, geo.Buffer[i + 1].y]]);
                    }
                    geometry = {
                        type: "MultiLineString",
                        coordinates: coord
                    }
                }
                else {
                    if (item.entityText) text = item.entityText.getParameter().label.text;
                    else text = "";
                    properties = {
                        "name": name,
                        "text": text,
                        "stroke": "#" + item.color,
                        "stroke-width": 2,
                        "stroke-opacity": 1,
                        "fill": "#" + item.color,
                        "fill-opacity": 0.8
                    }
                    let coord = geo.Bounds[0].Buffer.map(point => [point.x, point.y]);
                    geometry = {
                        type: "Polygon",
                        coordinates: [
                            [
                                ...coord,
                                coord[0]
                            ]
                        ]
                    }
                }

                exportData.features[index] = {
                    type: "Feature",
                    geometry: geometry,
                    properties: properties
                };
            });

            let options = {
                name: "name",
                simplestyle: true,
            }

            let blob = new Blob([tokml(exportData, options)], { type: "octet/stream" }),
                url = window.URL.createObjectURL(blob),
                a = document.createElement("a");
            a.href = url;
            a.download = "標註結果.kml";
            a.click();
            window.URL.revokeObjectURL(url);
        }
        else
            toast.current.show({ severity: 'error', summary: '標註資訊', detail: '沒有標註可以匯出' });
    }

    const markIconTemplate = (option) => {
        let url = `https://api.tiles.mapbox.com/v3/marker/pin-s-${option.icon}+${color}.png`;
        return (
            <div className="country-item">
                <img alt={option.name} id={option.name} src={url} className={`flag flag-${option.icon.toLowerCase()}`} />
                <div style={{ marginLeft: "1rem" }}>{option.name}</div>
            </div>
        );
    }

    return (
        <div>
            <Toast ref={toast} />
            <Dialog header="標註功能" visible={props.Mark} modal={false} keepInViewport={false} onHide={() => props.onHide('Mark')}>
                <Card>
                    <div className="field grid">
                        <label class="col-12 mb-4 md:col-4 md:mb-0">標註類型：</label>
                        <div className="col-12 md:col-8">
                            <Dropdown className="inputfield w-full" value={selectType} options={markType} onChange={(e) => setSelectType(e.value)} optionLabel="label" />
                        </div>
                    </div>
                    {
                        selectType === 0 ?
                            <div className="field grid">
                                <label class="col-12 mb-4 md:col-4 md:mb-0">標註Icon：</label>
                                <div className="col-12 md:col-8">
                                    <Dropdown className="inputfield w-full" value={selectMarkIcon} options={markIcons} filter optionLabel="name"
                                        onChange={(e) => setSelectMarkIcon(e.value)} itemTemplate={markIconTemplate} />
                                </div>
                            </div> : null
                    }
                    <div className="field grid">
                        <label class="col-12 mb-4 md:col-4 md:mb-0">標註顏色：</label>
                        <div className="col-12 md:col-8">
                            <ColorPicker value={color} onChange={(e) => setColor(e.value)} ></ColorPicker>
                        </div>
                    </div>
                    <div className="field grid">
                        <label class="col-12 mb-4 md:col-4 md:mb-0">顏色Hex碼：</label>
                        <div className="col-12 md:col-8">
                            <div className="p-inputgroup">
                                <span className="p-inputgroup-addon">#</span>
                                <InputText value={color} onChange={(e) => setColor(e.target.value)} />
                            </div>
                        </div>
                    </div>
                    <div className="field grid">
                        <label class="col-12 mb-4 md:col-4 md:mb-0">標註文字：</label>
                        <div className="col-12 md:col-8">
                            <InputText value={markText} onChange={(e) => setMarkText(e.target.value)} placeholder="Start Texting." style={{ width: "100%" }} />
                        </div>
                    </div>
                    <div className="field grid">
                        <div className="col-12 md:col-12">
                            <Button label="開始" icon="pi pi-check" className="p-button-rounded p-button-info" onClick={startMark} style={{ width: "100%" }} />
                        </div>
                    </div>
                    <div className="field grid">
                        <div className="col-12 md:col-6">
                            <Button label="清除上一個標註" icon="pi pi-undo" className="p-button-rounded p-button-danger" onClick={removeLastEmtity} style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 md:col-6">
                            <Button label="清除所有標註" icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={removeAllEmtity} style={{ width: "100%" }} />
                        </div>
                    </div>
                    <Button label="匯出標註(KML)" icon="pi pi-save" className="p-button-rounded p-button-warning" onClick={exportKML} style={{ width: "100%" }} />
                </Card>
            </Dialog>
        </div>
    );
}